module.exports = __webpack_public_path__ + "img/yy-b2.143342c2.png";